import './Image.scss';

import React, { useState } from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import Lightbox from 'react-images';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';

import ImageOverlayBox from 'components/ImageOverlayBox';

import { cxHelpers } from 'util/className';

const { cx } = cxHelpers('Image');

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  expandable?: boolean;
  containerClassName?: string;
  expandedSrc?: string;
  overlayI18n?: string;
  w?: string | number;
  h?: string | number;
  growOnHover?: boolean;
  grayscaled?: boolean;
  dimmed?: boolean;
}

const Image = ({
  src,
  alt,
  w = 'auto',
  h = 'auto',
  grayscaled = false,
  expandable,
  className,
  containerClassName,
  expandedSrc,
  overlayI18n,
  growOnHover,
  dimmed,
  ...props
}: ImageProps) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  let imageClassName = className || '';

  if (grayscaled) {
    imageClassName = `${imageClassName} ${cx('grayscaled')}`;
  }

  if (dimmed) {
    imageClassName = `${imageClassName} ${cx('dimmed')}`;
  }

  const image = (
    <img
      className={imageClassName}
      src={src}
      alt={alt}
      style={{ height: h, width: w }}
      {...props}
    />
  );

  if (expandable || expandedSrc) {
    return (
      <Box
        data-testid="expandable-image-container"
        className={cx({ growOnHover })}
        h={h}
        w={w}
        relative
      >
        <a
          data-testid="expandable-image-link"
          className={containerClassName}
          onClick={handleOpen}
        >
          {image}
          {overlayI18n && (
            <ImageOverlayBox>
              <Text i18n={overlayI18n} />
            </ImageOverlayBox>
          )}
          <Lightbox
            images={[{ src: expandedSrc || src }]}
            isOpen={open}
            onClose={handleClose}
            backdropClosesModal
          />
        </a>
      </Box>
    );
  }

  return image;
};

export default Image;
